module.exports = __webpack_public_path__ + "media/src/images/icon/point-f100eead2e5e95e15ca3eb834a87b40f.svg";